import { render, staticRenderFns } from "./ConfirmBdoCard.vue?vue&type=template&id=4a18076a&"
import script from "./ConfirmBdoCard.vue?vue&type=script&lang=js&"
export * from "./ConfirmBdoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports